import { decl } from '@yandex-lego/i-bem-react';
import _tableauNode__hiddenLinks from "./__hidden-links/tableau-node__hidden-links.react.js";

var HiddenLinks = _tableauNode__hiddenLinks.applyDecls();

import "./__hidden-links/tableau-node__hidden-links.css";
import _tableauNode__links from "./__links/tableau-node__links.react.js";

var Links = _tableauNode__links.applyDecls();

export default decl({
    block: 'tableau-node'
}, {
    HiddenLinks: HiddenLinks,
    Links: Links
});